import type { App, DirectiveBinding } from 'vue';
import { useEventListener } from '@vueuse/core';

import { assertValue } from '@libs/utils';

export function addCustomDirectives(app: App<Element>): void {
  app.directive('focus', {
    mounted(input: HTMLInputElement, binding: DirectiveBinding<boolean>) {
      if (binding.value) {
        input.focus();
      }
    },
    updated(input: HTMLInputElement) {
      if (input.value === '') {
        input.focus();
      }
    },
  });

  app.directive('visible', function (el, binding) {
    el.style.visibility = binding.value ? 'visible' : 'hidden';
  });

  app.directive('resize', {
    mounted: function (_el, binding) {
      const onResizeCallback = binding.value;

      useEventListener(window, 'resize', () => {
        assertValue(
          binding.arg,
          "directives > app.directive('resize') > binding.arg"
        );

        const value = document.documentElement[binding.arg];
        onResizeCallback(value);
      });
    },
  });
}
